module.exports = {"id":"190471","name":"Bernard Parker","rating":"72","photo":"./data/images/photos/3/190471.png","club":{"name":"Kaizer Chiefs","logo":"./data/images/clubs/KaizerChiefs.png"},"positions":["ATT","BU","MG","MOC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/BernardParker0.json
// module id = 588
// module chunks = 0